export default {
  messages: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/general/state.js